import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Dashboard from "../Dashboard/Dashboard";
import "../../components/Profile/Profile.css";
import "./UserSubcription.css";
import "../../components/ResultTwo/ResultTwo.css";
import yellow from "../../images/yellowbadge.svg";

import redb from "../../images/red-badge.svg";
import grap from "../../images/greybadge.svg";
import pur from "../../images/purple-badge.svg";
import yel from "../../images/yellowbadge.svg";
import { useNavigate } from 'react-router-dom';
import { END_URL, IMG_URL } from "../../config";

import loadimg from "../../images/loader_wish.gif";

function UserSubcription({ token,onLoginChange, globaltest }) {

   const [loading, setLoading] = useState(false);

   const [SubDetail, setSubDetail] = useState([]);

  const [deletingId, setDeletingId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedAttemptId, setSelectedAttemptId] = useState(null);

  const [cancelContent,setCancelContent] = useState(null);

  const navigate = useNavigate();

   function getBadgeimage(badgeimage) {

        const getBadgeimage = [yellow, redb, grap, pur, yel];

        return getBadgeimage[badgeimage] || yellow;
    }

      useEffect(() => {

          GetUserResult();

      }, [token]);

      const GetUserResult = async () => {

          setLoading(true);

          try {

              const response = await axios.get(`${END_URL}/user_subcriptions`, {
                  headers: { Authorization: `Bearer ${token}` }
              });

              const reponsedata = response?.data;

              setCancelContent(reponsedata?.subcription_cancel_content);

              setSubDetail(reponsedata?.user_payments);

              setLoading(false);

          }
          catch {

              console.log('some error ');
          }

      };

  const cancelRemove = () => {
    setShowConfirm(false);
    setSelectedAttemptId(null);
  };


  const handleCancelSub = async () => {

    if (!selectedAttemptId) return;

    setDeletingId(selectedAttemptId);

    try {
      const response = await axios.get(
        `${END_URL}/cancel-subscription/${selectedAttemptId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === 'success') {
        
        setDeletingId(null);
        setShowConfirm(false);
        setSelectedAttemptId(null);

        GetUserResult(); 
        
      }
    } 
    
    catch (error) {

      console.error(error);
      alert(
        error.response?.data?.message || 'Failed to cancel subscription'
      );

    } finally {

      setDeletingId(null);
      setShowConfirm(false);
      setSelectedAttemptId(null);
    }
  };


const SubscriptionRow = ({ item, onViewTests,ViewPage,onViewSingleTest,CancelSub}) => {
  const isOneTime = item?.user_subcription?.type === "one_time";
  const isMonthly = item?.user_subcription?.type === "monthly";

  const isYearly = item?.user_subcription?.month == 12;
  
  return (
    <tr className="subscription-row">

      <td className="subscription-title-cell" dangerouslySetInnerHTML={{ __html:item?.content }}/>
        
      <td className="subscription-price-cell">
        ${item.amount}
      </td>
      <td className="subscription-type-cell">

        {isMonthly ? (isYearly ? "Yearly" : "Monthly") : "One Time"}

      </td>
      <td className="subscription-tests-cell">
        {isOneTime && item?.result_exit ? (

            <span 
                className="view-tests-link"
                onClick={() => onViewSingleTest(item)}
                style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
            >
                View Result
            </span>

        ) : isMonthly && item?.result_exit ? (
          <span 
            className="view-tests-link"
            onClick={() => onViewTests(item)}
            style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
          >
            View Result
          </span>
        ) : (

           item?.user_subcription?.plan_type =='zoom' ? (

              <span 
                className="view-tests-link"
                onClick={() => ViewPage('zoom-meetings')}
                style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
              >
                  View

              </span>
            ):(

              item?.user_subcription?.plan_type =='deep_drive' ? (

                  <span 
                    className="view-tests-link"
                    onClick={() => ViewPage('past-attempts')}
                    style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                  >
                      View

                  </span>
                ):(

                  <span>No Result</span>
                )
            )
        )}
      </td>

     <td className="subscription-expiry-cell">

        {item.payment_date }

      </td>
      
      <td className="subscription-expiry-cell">
        {isMonthly ? item.expiry_date : "N/A"}
      </td>

      <td className="subscription-action-cell">

        {!item?.expire && isMonthly && item?.payment_type!='one_time' && item?.payment_status!='cancelled' ? (
            <button className="renew-button"
              onClick={() => CancelSub(item?.id)}
            >
              Cancel Subscription
            </button>
        ):
        (
            item?.expire ? (

              item?.payment_status =='cancelled' ? (

                  <span className="expired-text">Cancelled</span>
              
              ):(

                item?.payment_type=='one_time' ? (

                  <span className="expired-text">Completed</span>

                ):(

                    <span className="expired-text">Expired</span>
                )   
              )

            ):(

               item?.payment_type === 'ebook' || item?.payment_type === 'ebook_store' ? (

                  <button
                      className="renew-button"
                      onClick={() => {
                          const ebookFile = item?.ebook_details?.ebook_file;

                          if (!ebookFile) return;

                          const link = document.createElement('a');
                          link.href = `${IMG_URL}/d0/${ebookFile}/download`;
                          link.download = '';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                      }}
                  >
                      Download
                  </button>

              ) : (

                  <span className="expired-text">Ongoing</span>

              )
            )
        )}

      </td>
    </tr>
  );
};

const TestResultsModal = ({ isOpen, onClose, testResults, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay subscrip-table" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Test Results</h3>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {loading ? (


            <p>Loading results...</p>
          ) 
          
          : testResults && testResults.length > 0 ? (

            <div className="test-results-list">
              {testResults.map((result, index) => (
                <div key={index} className="test-result-item">

                  <div className="test-result-header">

                      {result?.test?.dilemma ? (

                        <strong>{result?.test?.name}</strong>

                        ) : (

                          <strong>{result?.test?.name}</strong>
                        )}

                  </div>

                  <div className="test-result-details">
                    
                    <p>
                      {result?.test?.dilemma ? (
                          <>
                              {/* <span className="result-label">Score :</span>

                              <span className="result-value">{result.result}</span> */}

                              <span className="result-label">ArcheType :</span> 

                              <span className="result-value">{result?.dilemma?.arche_type_title} {result.result}</span>
                          </>

                      ) : (

                          <>

                            <span className="result-label">ArcheType :</span> 

                            <span className="result-value">{result?.result_dimension?.name} ({result.result})</span>
                          </>
                      )}

                    </p>

                    <p>
                      <span className="result-label">Date:</span> 
                      <span className="result-value">{result?.created_at_formatted}</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>No test results found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

const SubscriptionsTable = ({ SubDetail }) => {

  const [showModal, setShowModal] = useState(false);
  const [selectedTests, setSelectedTests] = useState([]);
  const [loadingTests, setLoadingTests] = useState(false);

  const fetchTestResults = async (subscription) => {
    setLoadingTests(true);
    setShowModal(true);
    
    try {

      const response = await axios.get(`${END_URL}/sub_test_result/${subscription.id}`, {
          headers: { Authorization: `Bearer ${token}` }
      });

      const reponsedata = response?.data;

      const combinedResults = [
          ...(reponsedata.result || []),
          ...(reponsedata.dilemma_result || [])
      ];
      
        setSelectedTests(combinedResults);

    } catch (error) {

      console.error('Error fetching test results:', error);
      setSelectedTests([]);

    } finally {

      setLoadingTests(false);
    }

  };

   const fetchTestResultsSingle = async (subscription) => {

    setLoadingTests(true);
    setShowModal(true);
    
    try {

    const response = await axios.get(`${END_URL}/sub_test_result_single/${subscription.subcription_id}/${subscription.id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });

    const reponsedata = response?.data;
      
        setSelectedTests(reponsedata.result || []);
    } catch (error) {

      console.error('Error fetching test results:', error);
      setSelectedTests([]);

    } finally {

      setLoadingTests(false);
    }

  };

  const handleViewTests = (subscription) => {
    fetchTestResults(subscription);
  };

  const HandleViewPage = (url) => {

      navigate(`/${url}`);
  };

const handleViewSingleTests = (subscription) => {
    fetchTestResults(subscription);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTests([]);
  };

  const ConformModal =(payment_id) => {

      setSelectedAttemptId(payment_id);
      setShowConfirm(true);
  };



  return (
    <>
      <div className="table-container">
        {SubDetail && SubDetail.length > 0 ? (
          <table className="subscriptions-table">
            <thead>
              <tr>
                <th>Subscription</th>
                <th>Price</th>
                <th>Type</th>
                <th>View Results</th>
                <th>Subcription Date</th>
                <th>Next payment due Date</th>
                 <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {SubDetail.map((item, index) => (
                <SubscriptionRow 
                  key={index} 
                  item={item} 
                  onViewTests={handleViewTests}
                  ViewPage={HandleViewPage}
                  onViewSingleTest={handleViewSingleTests}
                  CancelSub={ConformModal}
                />
              ))}
            </tbody>
          </table>
        ) : (
          <div className="no-subscriptions">
            <p>No Subscriptions Taken</p>
          </div>
        )}
      </div>

      <TestResultsModal 
        isOpen={showModal}
        onClose={handleCloseModal}
        testResults={selectedTests}
        loading={loadingTests}
      />
    </>
  );
};


  return (
    <div>
      <div className="result-cont profileCont achiev">
        <div className="container-fluid">
          <div className="row">

            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

              <Dashboard globaltest={globaltest}  />
              
            </div>

              <div className={`col-12 col-sm-12 col-md-7 col-lg-7 profile-mid achiev-mid acheivement-cont user-subscription`}>

                             <div className="container">

                                <div className="content-section">

                                 {SubDetail && SubDetail.length > 0 ? (
                                      <>
                                        <h1 className="page-title">Subscription Details</h1>
                                        <SubscriptionsTable SubDetail={SubDetail} />
                                      </>
                                    ) : (
                                      <p>No subscription details found.</p>
                                  )}
                                  
                                </div>

                            </div>

                        {/* // )} */}
              </div>
          
          
          </div>
        </div>
      </div>


        {showConfirm && (
            <div className="modal fade show d-block zoom-remove-links" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Cancel Subscription</h5>
                    <button type="button" className="btn-close" onClick={cancelRemove}></button>
                  </div>

                  <div className="modal-body" dangerouslySetInnerHTML={{ __html:cancelContent }}/>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={cancelRemove}>
                      Cancel
                    </button>
                    <button type="button" className="btn btn-danger" onClick={handleCancelSub}>
                      {deletingId ? "Removing..." : "Yes, Remove"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
        )}

    </div>
  );
}

export default UserSubcription;
